import { useContext } from 'react';
import { Card, Chip, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { FeatureSubscriptionPaymentCycle, FeatureSubscriptionProductCode } from 'queries';

import { CardButtonGroupContext } from './card-button-group';

type Props = {
  payCycle?: FeatureSubscriptionPaymentCycle | null;
  id: number;
  title: string;
  subtitle?: string | null;
  showChip: boolean;
  chipLabel?: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  handleOnClick: Function;
  productCode: FeatureSubscriptionProductCode | null;
};

const useStyles = makeStyles(() => ({
  cardSelected: {
    border: '2px solid #3f51b5',
    borderRadius: '15px',
    height: '75px',
    width: '250px',
    cursor: 'pointer',
  },
  cardNotSelected: {
    border: '1px solid grey',
    borderRadius: '15px',
    height: '75px',
    width: '250px',
    cursor: 'pointer',
  },
  chip: {
    position: 'relative',
    overflow: 'hidden',
    marginLeft: '10px',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'linear-gradient(120deg, transparent, rgba(255,255,255,.5), transparent)',
      transform: 'translateX(-100%)',
      animation: '$shimmer 8s infinite',
    },
    '& > span': {
      position: 'relative',
    },
  },
  '@keyframes shimmer': {
    '0%': {
      transform: 'translateX(-100%)',
    },
    '60%': {
      transform: 'translateX(100%)',
    },
    '100%': {
      transform: 'translateX(100%)',
    },
  },
}));

export const CardButton = ({
  payCycle,
  id,
  title,
  subtitle,
  showChip,
  chipLabel,
  handleOnClick,
  productCode,
}: Props) => {
  const classes = useStyles();
  const { isSelected, setIsSelected } = useContext(CardButtonGroupContext);

  return (
    <Card
      className={clsx({
        [classes.cardSelected]: isSelected === id,
        [classes.cardNotSelected]: isSelected !== id,
      })}
      style={{ borderRadius: '15px' }}
      onClick={() => {
        setIsSelected(id);
        if (!payCycle) {
          handleOnClick(productCode);
        } else {
          handleOnClick(payCycle);
        }
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: '100%',
          marginLeft: '10px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <Typography variant="h6">
            <strong>{title}</strong>
          </Typography>
          {showChip && (
            <Chip className={classes.chip} label={chipLabel!} color="primary" size="small" />
          )}
        </div>
        {subtitle && <Typography variant="subtitle2">{subtitle}</Typography>}
      </div>
    </Card>
  );
};
